import React, { useState, useEffect } from 'react'
import {
 Col, Upload, Checkbox, Row, Icon, Button,
} from 'antd'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { detailMode, status, statusText } from '../constants'
import { Select } from '../styled'
import {
  GET_ROLES, GET_WAREHOUSE_LISTS, DRIVER_LIST, GET_CLIENTS, GET_SENDERS, GET_RECEIVERS,
  GAS_STATION_LIST,
} from '../../../constants/graphql/query'
import { UploadWithModal } from '../../../components/common'
import ROLE from '../../../constants/role'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
*/

const statusTextRenderer = (text) => {
  switch (text) {
    case status.ACTIVE:
      return statusText.ACTIVE
    case status.INACTIVE:
      return statusText.INACTIVE
    default:
      return text
  }
}

const CreateMode = ({ data, onChangeHandler }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}><UI.InputWithLabel {...data.props} width='100%' input={{ onChange: e => onChangeHandler(data.id, e.target.value) }} /></Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Select
            dropdown
            {...data.props}
          >
            {
              data.children.map(v => <Select.Option key={v.id} value={v.id}>{v.description}</Select.Option>)
            }
          </Select>
        </Col>
      )
    case 4:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup {...data.props} list={data.list} defaultCheckedValue={data.list[0].value} vertical={data.isVertical} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, mutationVariables,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel width='100%' {...data.props} input={{ disabled, defaultValue: data.id === 'status' ? statusTextRenderer(initialData[data.id]) : initialData[data.id], onChange: e => onChangeHandler(data.id, e.target.value) }} />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <Query
          query={GET_ROLES}
          variables={{ limit: 100 }}
        >{({ data: rolesData, loading, error }) => {
          if (loading) return <Col span={data.span}><UI.Loading /></Col>
          if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>
          return (
            <Col span={data.span}>
              <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
              <Select
                dropdown
                onSelect={e => onChangeHandler(data.id, e)}
                defaultValue={data.id === 'roleId' ? initialData.Roles[0].id : initialData[data.id]}
                disabled={disabled}
                {...data.props}
              >
                {
                  rolesData.RoleList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.description}</Select.Option>)
                }
              </Select>
            </Col>
          )
        }}

        </Query>
      )
    case 4:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup
            disabled={disabled}
            list={data.list}
            defaultCheckedValue={initialData[data.id]}
            vertical={data.isVertical}
            onChange={e => onChangeHandler(data.id, e.target.value)}
            {...data.props}
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 6:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.P margin='0 0 20px'>{data.id === 'firstname' ? `${initialData[data.id]} ${initialData.lastname}` : data.id === 'status' ? statusTextRenderer(initialData[data.id]) : initialData[data.id]}</UI.P>
          </UI.Div>
        </Col>
      )
    case 7:
      return (
        <Query
          query={GET_WAREHOUSE_LISTS}
        >{({ data: WarehouseLists, loading, error }) => {
          if (loading) return <Col span={data.span}><UI.Loading /></Col>
          if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>
          return (
            <Col span={data.span}>
              <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
              {
                WarehouseLists.warehouseList.data.list.map(warehouse => <Col span="8" key={warehouse.id}>
                  <Checkbox
                    key={warehouse.id}
                    disabled={disabled}
                    checked={(mutationVariables.warehouseId.find(mutationWarehouse => mutationWarehouse === warehouse.id))}
                    onChange={(e) => {
                      const isCheck = e.target.checked
                      onChangeHandler(data.id, {
                        isCheck,
                        warehouseId: warehouse.id,
                      })
                    }}
                  >{warehouse.warehouseName}</Checkbox></Col>)
              }
            </Col>
          )
        }}

        </Query>
      )
    case 8: {
      if (mutationVariables.roleId ? !(mutationVariables.roleId === 11) : !(initialData.Roles[0].id === 11)) return null
      const [driverDefault, setDriverDefault] = useState(true)
      const {
        data: driverData, loading, error, refetch,
      } = useQuery(DRIVER_LIST, { variables: { id: initialData[data.id] } })

      useEffect(() => {
        if (driverDefault && !loading && !_.isEmpty(driverData)) {
          if (refetch) {
            refetch({ id: undefined })
            setDriverDefault(false)
          }
        }
      }, [driverData])

      if (loading && _.isEmpty(driverData)) return <Col span={data.span}><UI.Loading /></Col>
      if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>

      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Select
            dropdown
            showSearch
            onSelect={e => onChangeHandler(data.id, e)}
            onSearch={e => refetch({ fullname: e })}
            filterOption={(input, option) => option.props.fullname.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            defaultValue={initialData[data.id]}
            disabled={disabled}
            {...data.props}
          >
            {
              driverData.DriverList.lists.map(v => <Select.Option key={v.id} value={v.id} fullname={v.fullname}>{v.fullname}</Select.Option>)
            }
          </Select>
        </Col>
      )
    }
    case 9: {
      if (mutationVariables.roleId ? !(mutationVariables.roleId === 12) : !(initialData.Roles[0].id === 12)) return null
      const {
        data: customerData, loading, error, refetch,
      } = useQuery(GET_CLIENTS)

      if (loading && _.isEmpty(customerData)) return <Col span={data.span}><UI.Loading /></Col>
      if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>

      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
              {
                mutationVariables?.customerId.map((customer, idx) => (
                  <Row key={customer.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                    <Col span={23}>
                      <Select
                        dropdown
                        showSearch
                        onSelect={(e) => {
                          const selected = _.find(customerData.getCustomerLists.lists, o => o.id === e)
                          const newList = _.cloneDeep(mutationVariables?.customerId)
                          newList[idx].customerId = e
                          newList[idx].companyName = selected.companyName
                          onChangeHandler(data.id, newList)
                          refetch({ companyName: '' })
                        }}
                        onSearch={e => refetch({ companyName: e })}
                        filterOption={(input, option) => option.props.companyName.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        defaultValue={customer.name}
                        disabled={disabled}
                        {...data.props}
                      >
                        {
                          customerData.getCustomerLists.lists.map(v => <Select.Option key={v.id} value={v.id} companyName={v.companyName}>{v.companyName}</Select.Option>)
                        }
                      </Select>
                    </Col>
                    <Col span={1}>
                      <Icon
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        onClick={() => {
                          if (!disabled) {
                            const oldList = _.cloneDeep(mutationVariables?.customerId)
                            _.remove(oldList, n => n.id === customer.id)
                            onChangeHandler(data.id, oldList)
                          }
                        }}
                      />
                    </Col>
                  </Row>
                ))
              }
          <UI.Div display='flex' width='100%' justifyContent='center'>
          <Button type="dashed" disabled={disabled} onClick={() => {
            onChangeHandler(data.id, [...mutationVariables?.customerId, { id: (Math.random() * 10000) }])
          }}>
            <Icon type="plus" /> เพิ่มผู้ติดต่อ
          </Button>
          </UI.Div>
        </Col>
      )
    }
    case 10: {
      if (mutationVariables.roleId ? !(mutationVariables.roleId === 13) : !(initialData.Roles[0].id === 13)) return null
      const [senderDefault, setSenderDefault] = useState(true)
      const {
        data: senderData, loading, error, refetch,
      } = useQuery(GET_SENDERS, { variables: { id: initialData[data.id] } })

      useEffect(() => {
        if (senderDefault && !loading && !_.isEmpty(senderData)) {
          if (refetch) {
            refetch({ id: undefined })
            setSenderDefault(false)
          }
        }
      }, [senderData])

      if (loading && _.isEmpty(senderData)) return <Col span={data.span}><UI.Loading /></Col>
      if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>

      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Select
            dropdown
            showSearch
            onSelect={e => onChangeHandler(data.id, e)}
            onSearch={e => refetch({ name: e })}
            filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            defaultValue={initialData[data.id]}
            disabled={disabled}
            {...data.props}
          >
            {
              senderData.SenderLocationList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}{v.branch}</Select.Option>)
            }
          </Select>
        </Col>
      )
    }
    case 11: {
      if (mutationVariables.roleId ? !(mutationVariables.roleId === 13) : !(initialData.Roles[0].id === 13)) return null
      const [receiverDefault, setReceiverDefault] = useState(true)
      const {
        data: receiverData, loading, error, refetch,
      } = useQuery(GET_RECEIVERS, { variables: { id: initialData[data.id] } })

      useEffect(() => {
        if (receiverDefault && !loading && !_.isEmpty(receiverData)) {
          if (refetch) {
            refetch({ id: undefined })
            setReceiverDefault(false)
          }
        }
      }, [receiverData])

      if (loading && _.isEmpty(receiverData)) return <Col span={data.span}><UI.Loading /></Col>
      if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>

      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Select
            dropdown
            showSearch
            onSelect={e => onChangeHandler(data.id, e)}
            onSearch={e => refetch({ name: e })}
            filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            defaultValue={initialData[data.id]}
            disabled={disabled}
            {...data.props}
          >
            {
              receiverData.ReceiverLocationList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}{v.branch}</Select.Option>)
            }
          </Select>
        </Col>
      )
    }
    case 12: {
      if (mutationVariables.roleId ? !(mutationVariables.roleId === ROLE.FUEL_FILLER.id) : !(initialData.Roles[0].id === ROLE.FUEL_FILLER.id)) return null
      const [gasstationDefault, setGasstationDefault] = useState(true)
      const {
        data: gasstationData, loading, error, refetch,
      } = useQuery(GAS_STATION_LIST, { variables: { id: initialData[data.id] } })

      useEffect(() => {
        if (gasstationDefault && !loading && !_.isEmpty(gasstationData)) {
          if (refetch) {
            refetch({ id: undefined })
            setGasstationDefault(false)
          }
        }
      }, [gasstationData])

      if (loading && _.isEmpty(gasstationData)) return <Col span={data.span}><UI.Loading /></Col>
      if (error) return <Col span={data.span}><UI.H4>เกิดข้อผิดพลาด</UI.H4></Col>

      return (
        <Col span={data.span}>
          <UI.P display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Select
            dropdown
            showSearch
            onSelect={e => onChangeHandler(data.id, e)}
            onSearch={e => refetch({ name: e })}
            filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            defaultValue={initialData[data.id]}
            disabled={disabled}
            {...data.props}
          >
            {
              gasstationData.GasstationList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
            }
          </Select>
        </Col>
      )
    }
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={(id, value) => onChangeHandler(id, value)} />
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)} mutationVariables={mutationVariables} />
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)} mutationVariables={mutationVariables} />
    default:
      return <p>no mode</p>
  }
}
